import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  CostCenterDto,
  CostCenterListDto,
  CostCenterTreeNodeDto,
  CostCenterFilterDto,
  CreateCostCenterRequest,
  UpdateCostCenterRequest,
} from '@/types/costCenter.types';

export const costCenterApi = {
  /** GET /api/v1/cost-centers — paginated list with optional search/filter */
  getList: (filter?: CostCenterFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<CostCenterListDto>>>('/cost-centers', {
      params: filter,
    }),

  /** GET /api/v1/cost-centers/{id} — full cost center record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<CostCenterDto>>(`/cost-centers/${id}`),

  /** GET /api/v1/cost-centers/by-code/{code} — returns 404 when not found */
  getByCode: (code: string) =>
    apiClient.get<ApiResponse<CostCenterDto>>(
      `/cost-centers/by-code/${encodeURIComponent(code)}`,
    ),

  /** GET /api/v1/cost-centers/tree — full hierarchical tree */
  getTree: () =>
    apiClient.get<ApiResponse<CostCenterTreeNodeDto[]>>('/cost-centers/tree'),

  /** POST /api/v1/cost-centers — create a new cost center */
  create: (data: CreateCostCenterRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/cost-centers', data),

  /** PUT /api/v1/cost-centers/{id} — update cost center details */
  update: (id: string, data: UpdateCostCenterRequest) =>
    apiClient.put<ApiResponse<object>>(`/cost-centers/${id}`, data),

  /** DELETE /api/v1/cost-centers/{id} — soft-delete the cost center */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/cost-centers/${id}`),
};
